export default __webpack_public_path__ + "01ae037bec75366b19292cc86a61b1a4.png";